import { useState, useEffect } from 'react';
import { getKey } from '../utils/tokenStorage';

/**
 * Custom hook for persisting state in localStorage, now with app-specific prefixing.
 * @param {string} key - localStorage key (un-prefixed)
 * @param {any} initialValue - Initial value for the state
 * @returns {[any, Function]} - Returns state value and setter function
 */
const useLocalStorage = (key, initialValue) => {
  const prefixedKey = getKey(key);

  const [value, setValue] = useState(() => {
    try {
      const storedValue = localStorage.getItem(prefixedKey);
      return storedValue !== null ? JSON.parse(storedValue) : initialValue;
    } catch (error) {
      console.error(`Error retrieving ${prefixedKey} from localStorage:`, error);
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(prefixedKey, JSON.stringify(value));
    } catch (error) {
      console.error(`Error storing ${prefixedKey} in localStorage:`, error);
    }
  }, [prefixedKey, value]);

  return [value, setValue];
};

export default useLocalStorage;